import { IResponse, IUptimerobotResponse, monitorsInstance } from 'services';

import { IUptimerobotParams } from './misc.types';

export const MiscResources = {
  getMonitors: (params?: IUptimerobotParams): IResponse<IUptimerobotResponse> =>
    monitorsInstance.post('/getMonitors', params),
};
